import { Injectable } from '@angular/core';
import { StageService } from '../services/stage.service';
import { ObjectCheckerService } from '../services/object-checker.service';
declare let THREE: any;

@Injectable()
export class RoomStateManagerService {

  projectName: string;
  constructor(private stage: StageService,
  private objectCheckerSrvc: ObjectCheckerService) { }

  colorScheme = [
    // {scheme:..,objectId:...}
  ];

  wall = [];
  wallCopy = 0;

  isLacquer = true;
  isApplyColorToAll = true;

  trimAndFiller = [];
  quantityAllAddition;

  // REFACTOR
  // make an array with string for each wall
  savedWallMaterial;
  savedFloorMaterial;

  //store room points as array of {x:0,y:0,depth:0}
  roomPoints;

  //store room points as vector array 
  points = [];

  lastColorScheme = 'MahNaturalLaq';

  priceTemp = 0;

  getColorSchemeByObjectId(objectId) {
    var i = 0,
      item;
    for (; i < this.colorScheme.length; i++) {
      item = this.colorScheme[i];
      if (item.objectId === objectId)
        return item;
    }
    return null;
  }

  isInArray(el, array) {
    var check = false;
    for (var i = 0; i < array.length; i++) {

      if (array[i] == el) {
        check = true;
      }
    }
    return check;
  }

  convertPoints(roomPoints) {
    var result = [],
      i = 0,
      point;

    for (; i < roomPoints.length; i++) {
      point = roomPoints[i];
      result.push(new THREE.Vector3(point.x, 0, point.y));
    }

    return result;
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }


  saveWallLengthErrorMargin(val) {
    this.wallCopy = 0;
    for (var i = 0; i < this.wall.length; i++) {
      if (val.name == this.wall[i].name) {
        this.wallCopy++
        this.wall[i].wallLength = val.wallLength;
        this.wall[i].wallLengthInUnits = val.wallLengthInUnits;
      }
    }
    if (this.wallCopy == 0) {
      this.wall.push(val);
    }
  }

  getWallLengthErrorMargin() {
    return this.wall;
  }

  calculateWallErrorMargin() {
    return 1.27;
  }

  setPriceTemp(val) {
    this.priceTemp = val;
  }

  getPriceTemp() {
    return this.priceTemp;
  }

  getSavedWallMaterial() {
    return this.savedWallMaterial;
  }

  setWallMaterial(val) {
    this.savedWallMaterial = val;
  }

  getSavedFloorMaterial() {
    return this.savedFloorMaterial;
  }

  setFloorMaterial(val) {
    this.savedFloorMaterial = val;
  }

  clearCurrentRoomState() {
    this.colorScheme.length = 0;
    this.roomPoints = [];
    this.points = [];
  }
  saveObjectColorScheme(data) {

    var item = this.getColorSchemeByObjectId(data.objectId);
    if (item) {
      if (data.updateIfExist !== false)
        item.scheme = data.scheme;
    } else {
      this.colorScheme.push({
        objectId: data.objectId,
        scheme: data.scheme
      });
    }
  }

  testOnSaveObject() {

    for (var o = 0; o <= this.colorScheme.length - 1; o++) {
      var obj = this.colorScheme[o].objectId;
      var reduction = obj.substr(0, 5);
      if (reduction !== 'Wall ') {
        if (reduction !== 'FLOOR') {
          return this.colorScheme[o];
        }
      }
    }
  }

  getObjectsColorSchemes() {
    return this.colorScheme;
  }

  // not in use
  // but should be
  removeObjectColorScheme(objectId) {
    var item = this.getColorSchemeByObjectId(objectId);
    if (item) {
      var index = this.colorScheme.indexOf(item);
      this.colorScheme.splice(index, 1);
    }
  }

  // getColorSchemeByObjectId: getColorSchemeByObjectId

  setPoints(pts) {
    //  var clone = points.slice(0);
    this.roomPoints = pts;
    this.points = this.convertPoints(pts);
  }

  getNextPointIndex(index) {
    return index === this.roomPoints.length - 1 ? 0 : index + 1;
  }

  getPrevPointIndex(index) {
    return index === 0 ? this.roomPoints.length - 1 : index - 1;
  }

  getPoint(index) {
    return this.points[index];
  }

  getPoints() {
    return this.points;
  }

  getPointsToBuild() {
    return this.stage.getFloor().userData.points;
  }

  updatePoint(index, point, depth) {
    var p = this.roomPoints[index];
    p.x = point.x;
    p.y = point.z;
    p.depth = depth || p.depth;
    this.points[index].set(point.x, 0, point.z);
  }

  getRoomPoints() {
    return this.roomPoints;
  }

  insertPoint(addIndex, point) {
    this.roomPoints.splice(addIndex, 0, point);
    this.points.splice(addIndex, 0, new THREE.Vector3(point.x, 0, point.z));
  }

  hasPoints() {
    return this.roomPoints && this.roomPoints.length !== 0;
  }

  removePoint(index) {
    this.roomPoints.splice(index, 1);
    this.points.splice(index, 1);
  }

  setLastColorScheme(colorScheme) {
    this.lastColorScheme = colorScheme;
  }

  getLastColorScheme() {
    return this.lastColorScheme;
  }

  getCurrentNumberColor(celectedColor, materials) {

    if (celectedColor.colorSchemeUniqueName !== undefined) {
      celectedColor = celectedColor.colorSchemeUniqueName;
    }

    for (var i = 0; i <= materials.length; i++) {
      if (materials[i].colorSchemeUniqueName == celectedColor) {
        return i;
      }
    }
  }

  getFinish() {
    var finishNotUnique = [];
    for (var i = 0; i < this.colorScheme.length; i++) {
      var el = this.colorScheme[i];
      if (typeof el.scheme === 'object' && el.scheme !== "undefined") {
        finishNotUnique.push((el.scheme.stain).charAt(0).toUpperCase() + (el.scheme.stain).slice(1));

      }
    }
    var finish = finishNotUnique.filter(this.onlyUnique);
    return finish;
  }

  getWoodSpecies() {
    var woodSpeciesNotUnique = [];
    for (var i = 0; i < this.colorScheme.length; i++) {
      var el = this.colorScheme[i];
      if (typeof el.scheme === 'object' && el.scheme !== "undefined") {
        woodSpeciesNotUnique.push(el.scheme.colorSchemeName);
      }
    }
    var woodSpecies = woodSpeciesNotUnique.filter(this.onlyUnique);
    return woodSpecies;
  }

  setIsLacquer(val) {
    this.isLacquer = val;
  }

  getIsLacquer() {
    return this.isLacquer;
  }

  setTrimAndFiller(val) {
    this.trimAndFiller = val;
  }

  getTrimAndFiller() {
    return this.trimAndFiller;
  }

  setQuantityAllAddition(val) {
    this.quantityAllAddition = val;
  }
  getQuantityAllAddition() {
    return this.quantityAllAddition;
  }

  setIsApplyColorToAll(val) {
    this.isApplyColorToAll = val;
  }

  getIsApplyColorToAll() {
    return this.isApplyColorToAll;
  }

  getTotalBottlesCount() {
    let objects = this.stage.getChildren();
    let racks = objects.filter(function (obj) { return this.objectCheckerSrvc.isVigilant(obj); });
    let bottlesCount = racks.reduce((sumCount, obj) => {
      return sumCount + obj.userData.entity.total_bottles;
    }, 0);
    return bottlesCount;
  }

  getProductsTotalWeight() {
    let objects = this.stage.getChildren();
    let racks = objects.filter(function (obj) { return this.objectCheckerSrvc.isVigilant(obj); });
    let totalWeight = racks.reduce((sumCount, obj) => {
      return sumCount + obj.userData.entity.lbs;
    }, 0);
    return totalWeight;
  }

  setProjectName(name: string) {
    this.projectName = name;
  }

  getProjectName() {
    return this.projectName;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/room-state-manager.service.ts